<template>
  <div class="email-page-template">
    <div v-if="consentLoading" class="loading-email">
      <p>
        <i class="fa fa-spinner fa-spin" />
      </p>
    </div>
    <div class="email-wrapper" v-else>
      <b>Please {{brandConsentForm.user_agree ? 'confirm' : 'input'}} your email address:</b>
      <Input @on-enter="preventEnter" v-model="email" @on-change="validateEmail" />
    </div>
  </div>
</template>

<script>
import Utils from "@/utils.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EmailPage",
  data() {
    return {
      consentLoading: false,
      brandConsentForm: {
        email: null,
        user_agree: false
      }
    };
  },
  computed: {
    ...mapGetters("user", ["brandInfo", "userInfo", "consent"]),
    email: {
      get() {
        return this.brandConsentForm.email;
      },
      set(v) {
        this.brandConsentForm.email = v;
      }
    }
  },
  mounted() {
    this.getUserConsent();
  },
  watch: {
    email(v) {
      this.validateEmail()
    }
  },
  methods: {
    ...mapActions("user", ["getBrandConsent"]),
    getUserConsent() {
      this.consentLoading = true;
      this.getBrandConsent({
        user_id: this.userInfo.id,
        brand_id: this.brandInfo.id
      }).then(
        res => {
          this.brandConsentForm = _.cloneDeep(this.consent);
          this.consentLoading = false;
        },
        err => {
          this.consentLoading = false;
        }
      );
    },
    preventEnter() {
      event.stopPropagation();
    },
    validateEmail() {
      this.$emit("isValid", Utils.validateEmail(this.email));
    }
  }
};
</script>

<style lang="scss" scoped>
.email-page-template {
  height: 100%;
}
.loading-email {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.email-wrapper {
  display: flex;
  flex-direction: column;
  b {
    margin-bottom: 10px;
  }
}
</style>